import Lottie from 'lottie-react';

import providers from '../jsons/Providers.json';

const Providers = props => {
  return <Lottie animationData={providers} {...props} />;
};

export default Providers;
